import { CatchPraise } from "@/components/catchPraise";
import { MEDIA } from "@/styles/common";
import { Box, Flex, Spinner } from "@chakra-ui/react";
import { useGetCommon, type AboutInfoResponse } from "@shared/server";

export const AboutIntro = () => {
    const { data } = useGetCommon<AboutInfoResponse>({ section: "about" });
    const { isMobile } = MEDIA();

    return data ? (
        <Flex
            as="section"
            columnGap="24px"
            rowGap={isMobile ? "24px" : ""}
            position="relative"
            zIndex={3}
            flexDir={isMobile ? "column" : "row"}
        >
            <Flex w="100%" flexDir="column" rowGap={isMobile ? "24px" : "120px"}>
                <CatchPraise catchPraise={data.catchPraise} annotation="About" isDetail={false} />
                <Box
                    background={`url(${data.imgList[0].imgUrl}) no-repeat center/cover`}
                    w={isMobile ? "100" : "80%"}
                    h={isMobile ? "264px" : "742px"}
                />
            </Flex>
            <Flex w="100%" flexDir="column" rowGap={isMobile ? "24px" : "160px"} alignItems="flex-end">
                {data.imgList.slice(1, 3).map((img) => (
                    <Box
                        key={img.imgUrl}
                        background={`url(${img.imgUrl}) no-repeat center/cover`}
                        _first={{ width: "100%", height: isMobile ? "264px" : "548px" }}
                        _last={{ width: isMobile ? "100%" : "80%", height: isMobile ? "264px" : "440px" }}
                    />
                ))}
            </Flex>
        </Flex>
    ) : (
        <Spinner />
    );
};
